import React, { ReactNode } from 'react';
import { View, StyleSheet, ViewStyle, StyleProp } from 'react-native';

type Props = {
  children: ReactNode;
  containerStyle?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
};

const BasicModalContainer = ({ children, containerStyle, contentStyle }: Props) => {
  return (
    <View style={[styles.bootstrapModal, containerStyle]}>
      <View style={[styles.modalContent, contentStyle]}>{children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  bootstrapModal: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    flexDirection: 'column',
    maxHeight: '90%',
    backgroundColor: 'white',
    borderRadius: 5,
    padding: 10,
  },
});

export default BasicModalContainer;